import { ApplicableFilter } from '../../services/types/services'

export const getNoResultsClearFiltersEventLabel = (
  payload: { filter: ApplicableFilter }[],
): string => {
  const filter = payload[0].filter
  const isIntegerFilter = filter?.__typename === 'IntegerFilter'

  return isIntegerFilter
    ? `${filter.selectedValueLabel} filter`
    : `${filter.label} filter`
}
